import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import { getLanguage, setLanguage } from '@/utils/cache'
import { LanguageList } from '@/model/globalData'

// 默认语言
const DefaultLocale = 'en'

// 遍历lang文件夹，获取国际化对象数据
const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.js$/i)
const supportLanguages = locales.keys().map((item) => {
  return item
    .split('/')
    .pop()
    .replace(/\.\w+$/, '')
})

// 本地缓存国际化配置 -> doc/3.国际化.md
export function loadLocale() {
  let locale = DefaultLocale
  const storageLanguage = getLanguage()
  const mySupport = []
  for (let i = 0; i < LanguageList.length; i++) {
    mySupport.push(LanguageList[i].value)
  }
  if (storageLanguage && mySupport.includes(storageLanguage)) {
    locale = storageLanguage
  } else {
    let browserLanguage = navigator.language || navigator.userLanguage
    browserLanguage = browserLanguage.substr(0, 2)
    if (mySupport.includes(browserLanguage)) {
      locale = browserLanguage
    } else {
      locale = DefaultLocale
    }
    setLanguage(locale)
  }

  return locale
}

// 加载多语言文件
function loadMessages() {
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = { ...(locales(key).default || locales(key)) }
    }
  })
  return messages
}

export default new VueI18n({
  locale: loadLocale(),
  messages: loadMessages(),
  fallbackLocale: DefaultLocale,
  silentTranslationWarn: true, // 去除国际化警告
})
